<template>
  <NuxtLayout>
    <ElocusPage
      is-error
      class="errorPage"
    />
  </NuxtLayout>
</template>
